module.exports = __webpack_public_path__ + "img/pubulish.0e11001c.png";